import TimelineTaskItem from './TimelineTaskItem';
export default {
  name: 'TimelineTaskList',
  props: ['tasks', 'name', 'title', 'color'],
  computed: {
    backgroundColor() {
      return this.color || '';
    }
  },
  components: {
    TimelineTaskItem
  }
};